import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import { Grid,OutlinedInput } from "@material-ui/core";


const useStyles = makeStyles(theme => ({
  formControl: {
    // margin: theme.spacing(1),
    width: "100%",

    // minWidth: 120,
    // maxWidth: 300
  },
  chips: {
    display: "flex",
    flexWrap: "wrap"
  },
  chip: {
    margin: 2
  },
  noLabel: {
    marginTop: theme.spacing(3)
  },
  gridRoot: {
    flexGrow: 1,
    marginBottom: "20px",
  },
}));

const MenuProps = {
  PaperProps: {
    style: {
      width: 250
    }
  }
};

const groups = {
  Male: [
    "Oliver Hansen",
    "Van Henry",
    "Ralph Hubbard",
    "Omar Alexander",
    "Carlos Abbott",
    "Bradley Wilkerson"
  ],
  Female: ["April Tucker", "Miriam Wagner", "Virginia Andrews", "Kelly Snyder"]
};

export const MultipleSelect = (props) => {

  const classes = useStyles();
  
  const {
    label,
    type,
    selectOptions,
    name,
    placeholder,
    required,
    defaultValue,
    disabled,
    readOnly,
    error,
    helperText,
    autoComplete,
    autoFocus,
    classNames,
    rows,
    rowsMax,
    color,
    value,
    apiVariable,
    params,
    index,
    isDynamicField,
    dropDown,
    field_name,
    handleChange,
  } = props.componentObject;
  const [personName, setPersonName] = React.useState(value);

  React.useEffect(() => {
    console.log(personName);
  }, [personName]);

  const handleValChange = event => {
    let chunks = [];

    if (event.target.value && event.target.value.length === 1) {
      chunks = event.target.value[0].split("-");
    } else if (event.target.value && event.target.value.length > 1) {
      chunks = event.target.value[event.target.value.length - 1].split("-");
    }

    if (chunks[0] === "Select" && chunks[1] === "All") {
      let groupName = chunks[chunks.length - 1];

      let names = [...personName];
      let allSelected = true;

      for (let name of groups[groupName]) {
        if (names.indexOf(name) < 0) {
          allSelected = false;
          break;
        }
      }

      for (let name of groups[groupName]) {
        if (names.indexOf(name) >= 0) {
          names.splice(names.indexOf(name), 1);
        }
      }

      if (!allSelected) {
        names = [...names, ...groups[groupName]];
      }

      setPersonName(names);
    } else {
      setPersonName(event.target.value);
    }
  };

  return (
    <div>
      <FormControl className={classes.formControl} fullWidth>
        {/* <InputLabel id="demo-mutiple-checkbox-label">Tag</InputLabel> */}
        <Select
           name={name} 
          labelId="demo-mutiple-checkbox-label"
          id="demo-mutiple-checkbox"
          multiple
          variant={"outlined"}
          value={value}
          onChange={(e) => handleChange(e.target.value, index)}
          input={<OutlinedInput />}

          // input={<Input />}
          renderValue={selected => selected.join(", ")}
          MenuProps={MenuProps}
        >
          {Object.keys(selectOptions).map(key => {
            let list = selectOptions[key].map(individual => {
              return (
                <MenuItem key={individual} value={individual}>
                  <Checkbox checked={value.indexOf(individual) > -1} />
                  <ListItemText primary={individual} />
                </MenuItem>
              );
            });

            list.unshift(
              <MenuItem key={key} value={`Select-All-${key}`}>
                <ListItemText primary={key} secondary="Select All/None" />
              </MenuItem>
            );

            return list;
          })}
        </Select>
      </FormControl>
    </div>
  );
}
export default function PhoneComponent(props) {
  const classes = useStyles();
  const { label,helpertext,errorMsg } = props.componentObject;
  return (
    // <form style={{ display: "flex", marginBottom: '20px' }} noValidate autoComplete="off">
    <Grid container className={classes.gridRoot}>
      {/* <div style={{ width: "25%" }}>{label}</div> */}
      <Grid item xs={12} md={4}>
        {label}
      </Grid>
      {/* <div style={{ width: "70%" }}> */}
      <Grid item xs={12} md={7} style={{width:'100%'}}>
        <MultipleSelect 
    style={{width:'100%',borderColor:'red'}} componentObject={props.componentObject} />
  {errorMsg !== undefined ?  <span style={{color: "#f44336",fontSize:'0.75rem',marginRight:'14px'}}>{errorMsg}</span> :''}
      </Grid>

    </Grid>
    // </form>
  );
}
